import React, { useRef } from 'react'
import { useGLTF, PerspectiveCamera } from '@react-three/drei'
import tribunas from '../models/tribunas.glb'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes } = useGLTF(tribunas)
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[-17, -4, -3]} scale={0.03} rotation={[-Math.PI / 2, 0, 0]}>
        <group position={[0, 0, 0]}>
          <group position={[0, 309.45, 187.16]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke.geometry} material={nodes.Concrete_Aggregate_Smoke.material} />
          </group>
          <group position={[0, 333.07, 198.98]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_1.geometry} material={nodes.Concrete_Aggregate_Smoke_1.material} />
          </group>
          <group position={[0, 285.83, 175.35]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_2.geometry} material={nodes.Concrete_Aggregate_Smoke_2.material} />
          </group>
          <group position={[0, 262.2, 163.54]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_3.geometry} material={nodes.Concrete_Aggregate_Smoke_3.material} />
          </group>
          <group position={[0, 238.58, 151.73]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_4.geometry} material={nodes.Concrete_Aggregate_Smoke_4.material} />
          </group>
          <group position={[0, 214.96, 139.92]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_5.geometry} material={nodes.Concrete_Aggregate_Smoke_5.material} />
          </group>
          <group position={[0, 191.34, 128.11]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_6.geometry} material={nodes.Concrete_Aggregate_Smoke_6.material} />
          </group>
          <group position={[0, 167.72, 116.3]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_7.geometry} material={nodes.Concrete_Aggregate_Smoke_7.material} />
          </group>
          <group position={[0, 144.09, 104.49]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_8.geometry} material={nodes.Concrete_Aggregate_Smoke_8.material} />
          </group>
          <group position={[0, 120.47, 92.68]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_9.geometry} material={nodes.Concrete_Aggregate_Smoke_9.material} />
          </group>
          <group position={[787.4, 333.07, 198.98]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_10.geometry} material={nodes.Concrete_Aggregate_Smoke_10.material} />
          </group>
          <group position={[787.4, 96.85, 80.87]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_11.geometry} material={nodes.Concrete_Aggregate_Smoke_11.material} />
          </group>
          <group position={[787.4, 285.83, 175.35]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_12.geometry} material={nodes.Concrete_Aggregate_Smoke_12.material} />
          </group>
          <group position={[787.4, 262.2, 163.54]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_13.geometry} material={nodes.Concrete_Aggregate_Smoke_13.material} />
          </group>
          <group position={[787.4, 238.58, 151.73]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_14.geometry} material={nodes.Concrete_Aggregate_Smoke_14.material} />
          </group>
          <group position={[787.4, 214.96, 139.92]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_15.geometry} material={nodes.Concrete_Aggregate_Smoke_15.material} />
          </group>
          <group position={[787.4, 191.34, 128.11]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_16.geometry} material={nodes.Concrete_Aggregate_Smoke_16.material} />
          </group>
          <group position={[787.4, 167.72, 116.3]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_17.geometry} material={nodes.Concrete_Aggregate_Smoke_17.material} />
          </group>
          <group position={[787.4, 120.47, 92.68]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_18.geometry} material={nodes.Concrete_Aggregate_Smoke_18.material} />
          </group>
          <group position={[984.25, 73.23, 69.05]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_19.geometry} material={nodes.Concrete_Aggregate_Smoke_19.material} />
          </group>
          <group position={[984.25, 144.09, 104.49]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_20.geometry} material={nodes.Concrete_Aggregate_Smoke_20.material} />
          </group>
          <group position={[984.25, 309.45, 187.16]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_21.geometry} material={nodes.Concrete_Aggregate_Smoke_21.material} />
          </group>
          <group position={[984.25, 333.07, 198.98]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_22.geometry} material={nodes.Concrete_Aggregate_Smoke_22.material} />
          </group>
          <group position={[984.25, 96.85, 80.87]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_23.geometry} material={nodes.Concrete_Aggregate_Smoke_23.material} />
          </group>
          <group position={[984.25, 285.83, 175.35]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_24.geometry} material={nodes.Concrete_Aggregate_Smoke_24.material} />
          </group>
          <group position={[984.25, 262.2, 163.54]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_25.geometry} material={nodes.Concrete_Aggregate_Smoke_25.material} />
          </group>
          <group position={[984.25, 238.58, 151.73]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_26.geometry} material={nodes.Concrete_Aggregate_Smoke_26.material} />
          </group>
          <group position={[984.25, 214.96, 139.92]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_27.geometry} material={nodes.Concrete_Aggregate_Smoke_27.material} />
          </group>
          <group position={[984.25, 191.34, 128.11]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_28.geometry} material={nodes.Concrete_Aggregate_Smoke_28.material} />
          </group>
          <group position={[984.25, 167.72, 116.3]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_29.geometry} material={nodes.Concrete_Aggregate_Smoke_29.material} />
          </group>
          <group position={[984.25, 120.47, 92.68]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_30.geometry} material={nodes.Concrete_Aggregate_Smoke_30.material} />
          </group>
          <group position={[1181.1, 73.23, 69.05]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_31.geometry} material={nodes.Concrete_Aggregate_Smoke_31.material} />
          </group>
          <group position={[1181.1, 144.09, 104.49]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_32.geometry} material={nodes.Concrete_Aggregate_Smoke_32.material} />
          </group>
          <group position={[1181.1, 309.45, 187.16]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_33.geometry} material={nodes.Concrete_Aggregate_Smoke_33.material} />
          </group>
          <group position={[1181.1, 333.07, 198.98]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_34.geometry} material={nodes.Concrete_Aggregate_Smoke_34.material} />
          </group>
          <group position={[1181.1, 96.85, 80.87]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_35.geometry} material={nodes.Concrete_Aggregate_Smoke_35.material} />
          </group>
          <group position={[1181.1, 285.83, 175.35]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_36.geometry} material={nodes.Concrete_Aggregate_Smoke_36.material} />
          </group>
          <group position={[1181.1, 262.2, 163.54]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_37.geometry} material={nodes.Concrete_Aggregate_Smoke_37.material} />
          </group>
          <group position={[1181.1, 238.58, 151.73]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_38.geometry} material={nodes.Concrete_Aggregate_Smoke_38.material} />
          </group>
          <group position={[1181.1, 214.96, 139.92]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_39.geometry} material={nodes.Concrete_Aggregate_Smoke_39.material} />
          </group>
          <group position={[1181.1, 191.34, 128.11]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_40.geometry} material={nodes.Concrete_Aggregate_Smoke_40.material} />
          </group>
          <group position={[1181.1, 167.72, 116.3]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_41.geometry} material={nodes.Concrete_Aggregate_Smoke_41.material} />
          </group>
          <group position={[1181.1, 120.47, 92.68]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_42.geometry} material={nodes.Concrete_Aggregate_Smoke_42.material} />
          </group>
          <group position={[787.4, 309.45, 187.16]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_43.geometry} material={nodes.Concrete_Aggregate_Smoke_43.material} />
          </group>
          <group position={[0, 96.85, 80.87]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_44.geometry} material={nodes.Concrete_Aggregate_Smoke_44.material} />
          </group>
          <group position={[0, 73.23, 69.05]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_45.geometry} material={nodes.Concrete_Aggregate_Smoke_45.material} />
          </group>
          <group position={[196.85, 309.45, 187.16]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_46.geometry} material={nodes.Concrete_Aggregate_Smoke_46.material} />
          </group>
          <group position={[196.85, 333.07, 198.98]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_47.geometry} material={nodes.Concrete_Aggregate_Smoke_47.material} />
          </group>
          <group position={[196.85, 96.85, 80.87]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_48.geometry} material={nodes.Concrete_Aggregate_Smoke_48.material} />
          </group>
          <group position={[196.85, 285.83, 175.35]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_49.geometry} material={nodes.Concrete_Aggregate_Smoke_49.material} />
          </group>
          <group position={[196.85, 262.2, 163.54]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_50.geometry} material={nodes.Concrete_Aggregate_Smoke_50.material} />
          </group>
          <group position={[196.85, 238.58, 151.73]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_51.geometry} material={nodes.Concrete_Aggregate_Smoke_51.material} />
          </group>
          <group position={[196.85, 214.96, 139.92]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_52.geometry} material={nodes.Concrete_Aggregate_Smoke_52.material} />
          </group>
          <group position={[196.85, 191.34, 128.11]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_53.geometry} material={nodes.Concrete_Aggregate_Smoke_53.material} />
          </group>
          <group position={[196.85, 167.72, 116.3]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_54.geometry} material={nodes.Concrete_Aggregate_Smoke_54.material} />
          </group>
          <group position={[196.85, 120.47, 92.68]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_55.geometry} material={nodes.Concrete_Aggregate_Smoke_55.material} />
          </group>
          <group position={[196.85, 73.23, 69.05]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_56.geometry} material={nodes.Concrete_Aggregate_Smoke_56.material} />
          </group>
          <group position={[196.85, 144.09, 104.49]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_57.geometry} material={nodes.Concrete_Aggregate_Smoke_57.material} />
          </group>
          <group position={[393.7, 73.23, 69.05]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_58.geometry} material={nodes.Concrete_Aggregate_Smoke_58.material} />
          </group>
          <group position={[393.7, 144.09, 104.49]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_59.geometry} material={nodes.Concrete_Aggregate_Smoke_59.material} />
          </group>
          <group position={[393.7, 309.45, 187.16]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_60.geometry} material={nodes.Concrete_Aggregate_Smoke_60.material} />
          </group>
          <group position={[393.7, 333.07, 198.98]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_61.geometry} material={nodes.Concrete_Aggregate_Smoke_61.material} />
          </group>
          <group position={[393.7, 96.85, 80.87]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_62.geometry} material={nodes.Concrete_Aggregate_Smoke_62.material} />
          </group>
          <group position={[393.7, 285.83, 175.35]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_63.geometry} material={nodes.Concrete_Aggregate_Smoke_63.material} />
          </group>
          <group position={[393.7, 262.2, 163.54]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_64.geometry} material={nodes.Concrete_Aggregate_Smoke_64.material} />
          </group>
          <group position={[393.7, 238.58, 151.73]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_65.geometry} material={nodes.Concrete_Aggregate_Smoke_65.material} />
          </group>
          <group position={[393.7, 214.96, 139.92]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_66.geometry} material={nodes.Concrete_Aggregate_Smoke_66.material} />
          </group>
          <group position={[393.7, 191.34, 128.11]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_67.geometry} material={nodes.Concrete_Aggregate_Smoke_67.material} />
          </group>
          <group position={[393.7, 167.72, 116.3]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_68.geometry} material={nodes.Concrete_Aggregate_Smoke_68.material} />
          </group>
          <group position={[393.7, 120.47, 92.68]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_69.geometry} material={nodes.Concrete_Aggregate_Smoke_69.material} />
          </group>
          <group position={[590.55, 73.23, 69.05]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_70.geometry} material={nodes.Concrete_Aggregate_Smoke_70.material} />
          </group>
          <group position={[590.55, 144.09, 104.49]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_71.geometry} material={nodes.Concrete_Aggregate_Smoke_71.material} />
          </group>
          <group position={[590.55, 309.45, 187.16]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_72.geometry} material={nodes.Concrete_Aggregate_Smoke_72.material} />
          </group>
          <group position={[590.55, 333.07, 198.98]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_73.geometry} material={nodes.Concrete_Aggregate_Smoke_73.material} />
          </group>
          <group position={[590.55, 96.85, 80.87]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_74.geometry} material={nodes.Concrete_Aggregate_Smoke_74.material} />
          </group>
          <group position={[590.55, 285.83, 175.35]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_75.geometry} material={nodes.Concrete_Aggregate_Smoke_75.material} />
          </group>
          <group position={[590.55, 262.2, 163.54]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_76.geometry} material={nodes.Concrete_Aggregate_Smoke_76.material} />
          </group>
          <group position={[590.55, 238.58, 151.73]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_77.geometry} material={nodes.Concrete_Aggregate_Smoke_77.material} />
          </group>
          <group position={[590.55, 214.96, 139.92]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_78.geometry} material={nodes.Concrete_Aggregate_Smoke_78.material} />
          </group>
          <group position={[590.55, 191.34, 128.11]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_79.geometry} material={nodes.Concrete_Aggregate_Smoke_79.material} />
          </group>
          <group position={[590.55, 167.72, 116.3]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_80.geometry} material={nodes.Concrete_Aggregate_Smoke_80.material} />
          </group>
          <group position={[590.55, 120.47, 92.68]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_81.geometry} material={nodes.Concrete_Aggregate_Smoke_81.material} />
          </group>
          <group position={[787.4, 73.23, 69.05]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_82.geometry} material={nodes.Concrete_Aggregate_Smoke_82.material} />
          </group>
          <group position={[787.4, 144.09, 104.49]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_83.geometry} material={nodes.Concrete_Aggregate_Smoke_83.material} />
          </group>
          <group position={[787.4, 340.95, 36.61]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_84.geometry} material={nodes.Concrete_Aggregate_Smoke_84.material} />
          </group>
          <group position={[16.14, 329.92, 140.94]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_85.geometry} material={nodes.Concrete_Aggregate_Smoke_85.material} />
          </group>
          <group position={[779.53, 329.92, 1.49]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_86.geometry} material={nodes.Concrete_Aggregate_Smoke_86.material} />
          </group>
          <group position={[984.25, 340.95, 36.61]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_87.geometry} material={nodes.Concrete_Aggregate_Smoke_87.material} />
          </group>
          <group position={[803.54, 329.92, 140.94]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_88.geometry} material={nodes.Concrete_Aggregate_Smoke_88.material} />
          </group>
          <group position={[212.99, 329.92, 140.94]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_89.geometry} material={nodes.Concrete_Aggregate_Smoke_89.material} />
          </group>
          <group position={[409.84, 329.92, 140.94]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_90.geometry} material={nodes.Concrete_Aggregate_Smoke_90.material} />
          </group>
          <group position={[606.69, 329.92, 140.94]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_91.geometry} material={nodes.Concrete_Aggregate_Smoke_91.material} />
          </group>
          <group position={[590.55, 340.95, 36.61]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_92.geometry} material={nodes.Concrete_Aggregate_Smoke_92.material} />
          </group>
          <group position={[393.7, 340.95, 36.61]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_93.geometry} material={nodes.Concrete_Aggregate_Smoke_93.material} />
          </group>
          <group position={[196.85, 340.95, 36.61]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_94.geometry} material={nodes.Concrete_Aggregate_Smoke_94.material} />
          </group>
          <group position={[992.13, 49.61, 57.24]} rotation={[0, 0, -Math.PI / 2]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_95.geometry} material={nodes.Concrete_Aggregate_Smoke_95.material} />
          </group>
          <group position={[976.38, 329.92, 1.49]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_96.geometry} material={nodes.Concrete_Aggregate_Smoke_96.material} />
          </group>
          <group position={[1181.1, 340.95, 36.61]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_97.geometry} material={nodes.Concrete_Aggregate_Smoke_97.material} />
          </group>
          <group position={[1000.39, 329.92, 140.94]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_98.geometry} material={nodes.Concrete_Aggregate_Smoke_98.material} />
          </group>
          <group position={[1188.98, 49.61, 57.24]} rotation={[0, 0, -Math.PI / 2]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_99.geometry} material={nodes.Concrete_Aggregate_Smoke_99.material} />
          </group>
          <group position={[1370.08, 329.92, 1.49]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_100.geometry} material={nodes.Concrete_Aggregate_Smoke_100.material} />
          </group>
          <group position={[1173.23, 329.92, 1.49]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_101.geometry} material={nodes.Concrete_Aggregate_Smoke_101.material} />
          </group>
          <group position={[1377.95, 340.95, 36.61]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_102.geometry} material={nodes.Concrete_Aggregate_Smoke_102.material} />
          </group>
          <group position={[1197.24, 329.92, 140.94]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_103.geometry} material={nodes.Concrete_Aggregate_Smoke_103.material} />
          </group>
          <group position={[7.87, 49.61, 57.24]} rotation={[0, 0, -Math.PI / 2]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_104.geometry} material={nodes.Concrete_Aggregate_Smoke_104.material} />
          </group>
          <group position={[0, 340.95, 36.61]} rotation={[Math.PI / 2, -Math.PI / 2, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_105.geometry} material={nodes.Concrete_Aggregate_Smoke_105.material} />
          </group>
          <group position={[204.72, 49.61, 57.24]} rotation={[0, 0, -Math.PI / 2]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_106.geometry} material={nodes.Concrete_Aggregate_Smoke_106.material} />
          </group>
          <group position={[401.58, 49.61, 57.24]} rotation={[0, 0, -Math.PI / 2]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_107.geometry} material={nodes.Concrete_Aggregate_Smoke_107.material} />
          </group>
          <group position={[598.42, 49.61, 57.24]} rotation={[0, 0, -Math.PI / 2]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_108.geometry} material={nodes.Concrete_Aggregate_Smoke_108.material} />
          </group>
          <group position={[385.83, 329.92, 1.49]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_109.geometry} material={nodes.Concrete_Aggregate_Smoke_109.material} />
          </group>
          <group position={[188.98, 329.92, 1.49]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_110.geometry} material={nodes.Concrete_Aggregate_Smoke_110.material} />
          </group>
          <group position={[582.68, 329.92, 1.49]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_111.geometry} material={nodes.Concrete_Aggregate_Smoke_111.material} />
          </group>
          <group position={[23.62, 314.17, 1.49]} rotation={[-Math.PI / 2, 0, -Math.PI]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_112.geometry} material={nodes.Concrete_Aggregate_Smoke_112.material} />
          </group>
          <group position={[795.28, 49.61, 57.24]} rotation={[0, 0, -Math.PI / 2]}>
            <mesh geometry={nodes.Concrete_Aggregate_Smoke_113.geometry} material={nodes.Concrete_Aggregate_Smoke_113.material} />
          </group>
        </group>
        <group position={[5, 338, 210]} rotation={[0, 0, -Math.PI / 2]}>
          <group position={[3.15, -1286.06, -368.11]} rotation={[Math.PI / 2, Math.PI / 2, 0]}>
            <group position={[1875.97, 368.11, -0.54]} rotation={[-Math.PI, 0, Math.PI]}>
              <mesh geometry={nodes.Metal_Aluminum_Anodized_15.geometry} material={nodes.Metal_Aluminum_Anodized_15.material} />
            </group>
            <group position={[1684.41, 368.11, -2.12]}>
              <mesh geometry={nodes.Metal_Aluminum_Anodized_16.geometry} material={nodes.Metal_Aluminum_Anodized_16.material} />
            </group>
            <mesh geometry={nodes.Metal_Aluminum_Anodized.geometry} material={nodes.Metal_Aluminum_Anodized.material} />
          </group>
          <group position={[3.15, -1482.91, -368.11]} rotation={[Math.PI / 2, Math.PI / 2, 0]}>
            <group position={[1875.97, 368.11, -0.54]} rotation={[-Math.PI, 0, Math.PI]}>
              <mesh geometry={nodes.Metal_Aluminum_Anodized_17.geometry} material={nodes.Metal_Aluminum_Anodized_17.material} />
            </group>
            <group position={[1684.41, 368.11, -2.12]}>
              <mesh geometry={nodes.Metal_Aluminum_Anodized_18.geometry} material={nodes.Metal_Aluminum_Anodized_18.material} />
            </group>
            <mesh geometry={nodes.Metal_Aluminum_Anodized_1.geometry} material={nodes.Metal_Aluminum_Anodized_1.material} />
          </group>
          <group position={[3.15, -892.36, -368.11]} rotation={[Math.PI / 2, Math.PI / 2, 0]}>
            <group position={[1875.97, 368.11, -0.54]} rotation={[-Math.PI, 0, Math.PI]}>
              <mesh geometry={nodes.Metal_Aluminum_Anodized_19.geometry} material={nodes.Metal_Aluminum_Anodized_19.material} />
            </group>
            <group position={[1684.41, 368.11, -2.12]}>
              <mesh geometry={nodes.Metal_Aluminum_Anodized_20.geometry} material={nodes.Metal_Aluminum_Anodized_20.material} />
            </group>
            <mesh geometry={nodes.Metal_Aluminum_Anodized_2.geometry} material={nodes.Metal_Aluminum_Anodized_2.material} />
          </group>
          <group position={[3.15, -1679.76, -368.11]} rotation={[Math.PI / 2, Math.PI / 2, 0]}>
            <group position={[1875.97, 368.11, -0.54]} rotation={[-Math.PI, 0, Math.PI]}>
              <mesh geometry={nodes.Metal_Aluminum_Anodized_21.geometry} material={nodes.Metal_Aluminum_Anodized_21.material} />
            </group>
            <group position={[1684.41, 368.11, -2.12]}>
              <mesh geometry={nodes.Metal_Aluminum_Anodized_22.geometry} material={nodes.Metal_Aluminum_Anodized_22.material} />
            </group>
            <mesh geometry={nodes.Metal_Aluminum_Anodized_3.geometry} material={nodes.Metal_Aluminum_Anodized_3.material} />
          </group>
          <group position={[3.15, -1089.21, -368.11]} rotation={[Math.PI / 2, Math.PI / 2, 0]}>
            <group position={[1875.97, 368.11, -0.54]} rotation={[-Math.PI, 0, Math.PI]}>
              <mesh geometry={nodes.Metal_Aluminum_Anodized_23.geometry} material={nodes.Metal_Aluminum_Anodized_23.material} />
            </group>
            <group position={[1684.41, 368.11, -2.12]}>
              <mesh geometry={nodes.Metal_Aluminum_Anodized_24.geometry} material={nodes.Metal_Aluminum_Anodized_24.material} />
            </group>
            <mesh geometry={nodes.Metal_Aluminum_Anodized_4.geometry} material={nodes.Metal_Aluminum_Anodized_4.material} />
          </group>
          <group position={[3.15, -695.51, -368.11]} rotation={[Math.PI / 2, Math.PI / 2, 0]}>
            <group position={[1875.97, 368.11, -0.54]} rotation={[-Math.PI, 0, Math.PI]}>
              <mesh geometry={nodes.Metal_Aluminum_Anodized_25.geometry} material={nodes.Metal_Aluminum_Anodized_25.material} />
            </group>
            <group position={[1684.41, 368.11, -2.12]}>
              <mesh geometry={nodes.Metal_Aluminum_Anodized_26.geometry} material={nodes.Metal_Aluminum_Anodized_26.material} />
            </group>
            <mesh geometry={nodes.Metal_Aluminum_Anodized_5.geometry} material={nodes.Metal_Aluminum_Anodized_5.material} />
          </group>
          <group position={[3.15, -498.66, -368.11]} rotation={[Math.PI / 2, Math.PI / 2, 0]}>
            <group position={[1875.97, 368.11, -0.54]} rotation={[-Math.PI, 0, Math.PI]}>
              <mesh geometry={nodes.Metal_Aluminum_Anodized_27.geometry} material={nodes.Metal_Aluminum_Anodized_27.material} />
            </group>
            <group position={[1684.41, 368.11, -2.12]}>
              <mesh geometry={nodes.Metal_Aluminum_Anodized_28.geometry} material={nodes.Metal_Aluminum_Anodized_28.material} />
            </group>
            <mesh geometry={nodes.Metal_Aluminum_Anodized_6.geometry} material={nodes.Metal_Aluminum_Anodized_6.material} />
          </group>
          <group position={[0, 393.7, 0]}>
            <mesh geometry={nodes.Metal_Aluminum_Anodized_7.geometry} material={nodes.Metal_Aluminum_Anodized_7.material} />
          </group>
          <group position={[0, 196.85, 0]}>
            <mesh geometry={nodes.Metal_Aluminum_Anodized_8.geometry} material={nodes.Metal_Aluminum_Anodized_8.material} />
          </group>
          <group position={[0, 787.4, 0]}>
            <mesh geometry={nodes.Metal_Aluminum_Anodized_9.geometry} material={nodes.Metal_Aluminum_Anodized_9.material} />
          </group>
          <group position={[0, 984.25, 0]}>
            <mesh geometry={nodes.Metal_Aluminum_Anodized_10.geometry} material={nodes.Metal_Aluminum_Anodized_10.material} />
          </group>
          <mesh geometry={nodes.Metal_Aluminum_Anodized_11.geometry} material={nodes.Metal_Aluminum_Anodized_11.material} />
          <group position={[0, 590.55, 0]}>
            <mesh geometry={nodes.Metal_Aluminum_Anodized_12.geometry} material={nodes.Metal_Aluminum_Anodized_12.material} />
          </group>
          <group position={[0, 1181.1, 0]}>
            <mesh geometry={nodes.Metal_Aluminum_Anodized_13.geometry} material={nodes.Metal_Aluminum_Anodized_13.material} />
          </group>
          <group position={[0, 1377.95, 0]}>
            <mesh geometry={nodes.Metal_Aluminum_Anodized_14.geometry} material={nodes.Metal_Aluminum_Anodized_14.material} />
          </group>
        </group>
      </group>
      <PerspectiveCamera makeDefault={false} far={2443.95} near={1067.87} fov={49.5} position={[1225.27, 474.54, -5297.27]} rotation={[-0.44, -0.95, -0.37]} />
      <PerspectiveCamera makeDefault={false} far={15268.69} near={14850.64} fov={49.5} position={[872.75, 4584.25, 9058.13]} rotation={[0, 0.06, 1.56]} />
      <PerspectiveCamera makeDefault={false} far={3879.98} near={2732.33} fov={49.5} position={[528.93, 6862.42, -61.89]} rotation={[-Math.PI / 2, 0.77, Math.PI]} />
      <PerspectiveCamera makeDefault={false} far={2297.44} near={1056.25} fov={49.5} position={[627.43, 5897.91, -22.71]} rotation={[-1.69, 0.86, -3.05]} />
      <PerspectiveCamera makeDefault={false} far={1182.93} near={0} fov={49.5} position={[535.76, 4923.7, -59.24]} rotation={[-1.75, 0.9, -3]} />
      <PerspectiveCamera makeDefault={false} far={386.7} near={0} fov={49.5} position={[-475.03, 3098.32, -36.4]} rotation={[1.63, -0.76, 0.04]} />
      <PerspectiveCamera makeDefault={false} far={0.1} near={0} fov={49.5} position={[9.42, 5664.93, -83.86]} rotation={[1.62, -0.2, 0.01]} />
      <PerspectiveCamera makeDefault={false} far={5099.66} near={3661.55} fov={49.5} position={[-1714.49, 5047.14, -73.95]} rotation={[-2.28, -1.43, 2.44]} />
      <PerspectiveCamera makeDefault={false} far={4638.98} near={3194.19} fov={49.5} position={[4785.53, 3735.89, 1145.15]} rotation={[0.4, 1.18, 1.14]} />
    </group>
  )
}
